'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgChatHelpCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M2 8c0 1.177.338 2.311.98 3.287-.21.238-.391.403-.54.498a.732.732 0 00.11 1.292c.248.105.562.167.94.167.391 0 .814-.068 1.26-.2C5.718 13.67 6.841 14 8 14c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6zm6.01.388c-.363 0-.568-.198-.588-.561L7.339 5.56c-.02-.376.267-.65.664-.65s.685.274.664.65l-.089 2.26c-.013.369-.212.567-.568.567zm0 2.095c-.41 0-.725-.267-.725-.664s.315-.664.725-.664c.404 0 .719.267.719.664 0 .404-.315.664-.719.664z", fill: "currentColor" }))));
}

module.exports = SvgChatHelpCircle;
//# sourceMappingURL=ChatHelpCircle.js.map
